import { useState, useEffect } from 'react';

const FALLBACK_LANG = 'en';

export type UseLocalizedImagePathOptions = {
  basePath: string;
  lang: string;
  fallback?: string;
  imagesBaseUrl?: string;
};

export function useLocalizedImagePath({
  basePath,
  lang,
  fallback = FALLBACK_LANG,
  imagesBaseUrl = '/images/welcome',
}: UseLocalizedImagePathOptions): string {
  const [effectivePath, setEffectivePath] = useState<string>(
    () => `${basePath}/${lang || fallback}`,
  );

  useEffect(() => {
    const resolvedLang = lang || fallback;
    if (!lang || lang === fallback) {
      setEffectivePath(`${basePath}/${resolvedLang}`);
      return;
    }

    const img = new Image();
    const resolvedLangUrl = new URL(
      `${imagesBaseUrl}/${basePath}/${lang}.png`,
      window.location.href,
    ).href;

    img.onload = () => setEffectivePath(`${basePath}/${lang}`);
    img.onerror = () => setEffectivePath(`${basePath}/${fallback}`);
    img.src = resolvedLangUrl;

    return () => {
      img.onload = null;
      img.onerror = null;
      img.src = '';
    };
  }, [basePath, lang, fallback, imagesBaseUrl]);

  return effectivePath;
}
